export { default as CustomBlockTitle } from './index.vue';
